module.exports = __webpack_public_path__ + "static/media/loginApple-black.en.c68de1ac.svg";